<template>
  <div>
    <Navbar />
    <div class="w-section page-header team">
      <div
        data-ix="navbar-grow"
        class="page-header-overlay default"
      >
        <div class="w-container container">
          <h1
            data-ix="fade-in-on-load"
            class="w-editable page-header-title"
          >
            Some of our Clients
          </h1>
        </div>
      </div>
    </div>
    <div class="w-section section">
      <div class="w-container container">
        <div class="w-dyn-list">
          <div class="w-dyn-items w-row w-clearfix">
            <div
              v-for="customer in customers"
              :key="customer.id"
              class="w-dyn-item w-col customer-item"
            >
              <div
                :class="imageClass(customer.class)"
                :style="backgroundImage(customer)"
                class="customer-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-section section white stats">
      <div class="w-container container">
        <div class="w-row stats-row">
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                20
              </div>
              <div class="stats-title description">
                Years in business
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                500,000+
              </div>
              <div class="stats-title description">
                Users
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                $100M+
              </div>
              <div class="stats-title description">
                In transactions
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                9
              </div>
              <div class="stats-title description">
                team members
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Navbar from '@/components/TheNavbar'
import Footer from '@/components/TheFooter'

export default {
  name: 'NotFound',
  components: {
    Navbar,
    Footer,
  },

  computed: {
    ...mapGetters({
      customers: 'allCustomers',
    }),
  },

  mounted() {
    this.fetchCustomers()
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },
  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },

  methods: {
    ...mapActions(['fetchCustomers']),
    backgroundImage(customer) {
      return {
        // eslint-disable-next-line
        'background-image': `url('${this.loadImg(customer)}')`,
      }
    },

    imageClass: function(size) {
      if (size === 'mini') {
        return 'customer-logo-mini'
      }
      if (size === 'sm') {
        return 'customer-logo-sm'
      }
      if (size === 'med') {
        return 'customer-logo-med'
      }
      if (size === 'lg') {
        return 'customer-logo-lg'
      }
    },

    loadImg(customer) {
      let logo
      if (this.customers) {
        // eslint-disable-next-line
        logo = require(`../assets/customer_logos/${customer.image}`)
      }
      return logo
    },
  },
}
</script>
<style>
.customer-item {
  width: 200px !important;
  margin: 20px;
}
.customer-logo-mini {
  width: 80px;
}
.customer-logo-sm {
  width: 100px;
}
.customer-logo-med {
  width: 140px;
}
.customer-logo-lg {
  width: 250px;
}
</style>
